// components
import { CenterPageTemplate } from '@/pwa/templates/CenterPageTemplate/CenterPageTemplate';
import { FloatingContent } from '@/pwa/molecules/FloatingContent/FloatingContent';

export interface SignInV2Props {
  onRegister: () => void;
  onSignIn: () => void;
}

export const SignInV2 = ({ onSignIn, onRegister }: SignInV2Props) => {
  return (
    <CenterPageTemplate>
      <FloatingContent
        isLogo
        title='Care Simplified'
        description='Real care experts at your fingertips to help you find, fund and understand the right care.'
        actions={[
          {
            label: 'Create account',
            variant: 'primary',
            onClick: onRegister,
          },
          {
            label: 'Sign in',
            variant: 'secondary',
            onClick: onSignIn,
          },
        ]}
      />
    </CenterPageTemplate>
  );
};

SignInV2.displayName = 'SignInV2';
export default SignInV2;
